import EditableQuantityCell from '../../../shared/EditableQuantityCell';
import CompactSelectField from '../../../../Forms/Input/CompactSelectField';

const TYPE_OPTIONS = [
  { value: 'INCREASE', label: 'Aumento' },
  { value: 'DECREASE', label: 'Disminución' },
];

// El DTO de línea trae el tipo ya traducido ("Aumento"/"Disminución") para
// las vistas de solo lectura; el select editable necesita el código crudo
// que espera el backend (INCREASE/DECREASE) — se traduce en ambos sentidos
// solo aquí, sin tocar el DTO ni las vistas de solo lectura.
const LABEL_TO_CODE: Record<string, 'INCREASE' | 'DECREASE'> = {
  Aumento: 'INCREASE',
  Disminución: 'DECREASE',
};

const toCode = (value: string): 'INCREASE' | 'DECREASE' =>
  (LABEL_TO_CODE[value] ?? value) as 'INCREASE' | 'DECREASE';

// Columnas de solo lectura (vista de detalle ya finalizado/aprobado/etc.) —
// sin selects ni inputs editables.
export const adjustmentProductColumns = [
  {
    accessor: 'productName',
    label: 'Producto',
  },
  {
    accessor: 'adjustmentType',
    label: 'Tipo',
  },
  {
    accessor: 'quantity',
    label: 'Cantidad',
    render: (_: any, row: any) => `${row.quantity} ${row.unitName ?? ''}`,
  },
];

export const buildAdjustmentProductColumns = (
  onChange: (
    detailId: number,
    adjustmentType: 'INCREASE' | 'DECREASE',
    quantity: number
  ) => void
) => [
  {
    accessor: 'productName',
    label: 'Producto',
  },
  {
    accessor: 'adjustmentType',
    label: 'Tipo',
    render: (_: any, row: any) => (
      <CompactSelectField
        name="adjustmentType"
        value={toCode(row.adjustmentType)}
        options={TYPE_OPTIONS}
        onChange={(e) =>
          onChange(row.id, e.target.value as 'INCREASE' | 'DECREASE', Number(row.quantity))
        }
        className="w-36"
      />
    ),
  },
  {
    accessor: 'quantity',
    label: 'Cantidad',
    render: (_: any, row: any) => (
      <EditableQuantityCell
        value={Number(row.quantity)}
        unitCode={row.unitName}
        onCommit={(qty) => onChange(row.id, toCode(row.adjustmentType), qty)}
      />
    ),
  },
];
